import { Dialog, Flex } from '@radix-ui/themes'
import { useEffect, useState } from 'react'

export type ViewCouponModalProps = {
  couponImageBlob: Blob
}

export const ViewCouponModal = ({ couponImageBlob }: ViewCouponModalProps) => {
  const [imageUrl, setImageUrl] = useState('')

  useEffect(() => {
    if (!couponImageBlob) {
      return
    }

    // Create a temporary URL for the blob
    const url = URL.createObjectURL(couponImageBlob)
    setImageUrl(url)

    // Cleanup when component unmounts
    return () => URL.revokeObjectURL(url)
  }, [couponImageBlob])

  return (
    <Dialog.Root defaultOpen={true}>
      <Dialog.Content>
        <Dialog.Description hidden>Coupon Barcode</Dialog.Description>

        <Dialog.Title hidden>Coupon Barcode</Dialog.Title>
        <Flex justify="center" direction="column">
          <img src={imageUrl} alt="coupon-barcode-image" />
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  )
}
